import { Component, OnInit, OnDestroy, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';

interface NoteState {
  charIndex: number;
  isDeleting: boolean;
  timeout: any;
}

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit, OnDestroy {
  public notes: { [id: string]: string } = {};
  public openMenuId: string | null = null;

  private readonly noteTexts: { [id: string]: string } = {
    'deprecated-cloudflare': 'Deprecated due to Cloudflare protection.',
    'limetracker-stores': 'Not published on Edge and Chrome due to piracy policies. It can be installed manually via GitHub.'
  };
  private readonly typeSpeedMin = 45;
  private readonly typeSpeedMax = 100;
  private readonly holdTime = 3000;
  private readonly gapTime = 700;
  private readonly deleteSpeedMin = 10;
  private readonly deleteSpeedMax = 20;

  private readonly noteStates: { [id: string]: NoteState } = {};

  constructor(private elementRef: ElementRef, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    Object.keys(this.noteTexts).forEach((id) => {
      this.notes[id] = '';
      this.noteStates[id] = { charIndex: 0, isDeleting: false, timeout: null };
      this.typeLoop(id);
    });
  }

  ngOnDestroy(): void {
    Object.values(this.noteStates).forEach((state) => clearTimeout(state.timeout));
  }

  toggleLinksMenu(id: string, event: Event): void {
    event.stopPropagation();
    this.openMenuId = this.openMenuId === id ? null : id;
  }

  @HostListener('document:click')
  closeLinksMenu(): void {
    this.openMenuId = null;
  }

  private randomBetween(min: number, max: number): number {
    return min + Math.random() * (max - min);
  }

  private typeLoop(id: string): void {
    const fullText = this.noteTexts[id];
    const state = this.noteStates[id];

    if (!state.isDeleting) {
      state.charIndex++;
      this.notes[id] = fullText.substring(0, state.charIndex);
      this.scrollNoteToEnd(id);

      if (state.charIndex === fullText.length) {
        state.isDeleting = true;
        state.timeout = setTimeout(() => this.typeLoop(id), this.holdTime);
        return;
      }
      state.timeout = setTimeout(() => this.typeLoop(id), this.randomBetween(this.typeSpeedMin, this.typeSpeedMax));
    } else {
      state.charIndex--;
      this.notes[id] = fullText.substring(0, state.charIndex);
      this.scrollNoteToEnd(id);

      if (state.charIndex === 0) {
        state.isDeleting = false;
        state.timeout = setTimeout(() => this.typeLoop(id), this.gapTime);
        return;
      }
      state.timeout = setTimeout(() => this.typeLoop(id), this.randomBetween(this.deleteSpeedMin, this.deleteSpeedMax));
    }
  }

  // Keep the visible window scrolled to the end of the text, so once it
  // overflows the available width it's the beginning that scrolls out of
  // view (like a text input caret), not the end.
  private scrollNoteToEnd(id: string): void {
    this.cdRef.detectChanges();
    const el: HTMLElement = this.elementRef.nativeElement.querySelector('.deprecated-note[data-note-id="' + id + '"]');
    if (el) {
      el.scrollLeft = el.scrollWidth;
    }
  }

}
